import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * ComparisonBadge - Badge para mostrar comparaciones con período anterior
 * @param {number} current - Valor actual
 * @param {number} previous - Valor anterior
 * @param {string} format - Formato del valor (para calcular correctamente)
 * @param {boolean} inverse - Si true, invierte los colores (menor es mejor)
 */
const ComparisonBadge = ({ current, previous, format = 'number', inverse = false }) => {
    if (previous === undefined || previous === null || previous === 0) {
        return null;
    }

    const currentVal = parseFloat(current) || 0;
    const previousVal = parseFloat(previous) || 0;

    // Calculate percentage change
    const change = previousVal !== 0
        ? ((currentVal - previousVal) / Math.abs(previousVal)) * 100
        : (currentVal > 0 ? 100 : 0);

    const isPositive = change > 0;
    const isNegative = change < 0;
    const isNeutral = change === 0;

    // Determine badge variant based on change direction and inverse flag
    let variant = 'secondary';
    if (!isNeutral) {
        if (inverse) {
            variant = isPositive ? 'danger' : 'success';
        } else {
            variant = isPositive ? 'success' : 'danger';
        }
    }

    // Determine arrow icon
    const arrow = isPositive ? '↑' : isNegative ? '↓' : '→';

    return (
        <Badge bg={variant} className="mt-1">
            {arrow} {Math.abs(change).toFixed(2)}%
        </Badge>
    );
};

export default ComparisonBadge;
